<template>
<div class="chapter">
<div class="inner_page">
<h1>Inhoudsopgave</h1>
<p><span href="#/c001" title="Link target outside of Sample">Titelpagina</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Copyright Pagina</span></p>
<p><a href="#/c003">HOOFDSTUK EEN</a></p>
<p><span href="#/c004" title="Link target outside of Sample">Hoofdstuk Twee</span></p>
<p><span href="#/c005" title="Link target outside of Sample">HOOFDSTUK DRIE</span></p>
<p><span href="#/c006" title="Link target outside of Sample">CHAPTER FOUR</span></p>
<p><span href="#/c007" title="Link target outside of Sample">Hoofdstuk Vijf</span></p>
<p><span href="#/c008" title="Link target outside of Sample">HOOFDSTUK ZES</span></p>
<p><span href="#/c009" title="Link target outside of Sample">HOOFDSTUK ZEVEN</span></p>
<p><span href="#/c010" title="Link target outside of Sample">HOOFDSTUK 8</span></p>
<p><span href="#/c011" title="Link target outside of Sample">HOOFDSTUK NEGEN</span></p>
<p><span href="#/c012" title="Link target outside of Sample">Hoofdstuk 10</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?ba156fe0